/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from './../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Vehicle-Outline Icon component.
 */
export const AssetVehicleOutlinedIcon = (props: IconProps) => {
  const {color, size = IconSize.large, stroke} = props;
  const {iconSize} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
      <circle cx="13.1622" cy="25.7554" r="2.54546" stroke={stroke as any} strokeWidth="1.5"/>
      <circle cx="28.0684" cy="25.7554" r="2.54546" stroke={stroke as any} strokeWidth="1.5"/>
      <path d="M14.9546 25.7442H21.9994V11C21.9994 10.4477 21.5517 10 20.9994 10H6C5.44772 10 5 10.4477 5 11V24.7442C5 25.2964 5.44772 25.7442 6 25.7442H11.0356" stroke={stroke as any} strokeWidth="1.5"/>
      <path d="M22.0005 12.7744L28.4879 12.7744C28.8096 12.7744 29.1116 12.9291 29.2995 13.1902L33.8117 19.4586C33.9342 19.6288 34.0001 19.8332 34.0001 20.0428V25.7402H30.2519M22.0005 25.7402H25.6487" stroke={stroke as any} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
};

export default AssetVehicleOutlinedIcon;
